import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { ProductCollection } from '@models/productCollection';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createSafeStorage, createSizePartialize } from '@utils/localStorage';

const PAGE_SIZE = 20;

interface ProductCollectionsContainer {
  contents: ProductCollection[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

interface ProductCollectionsStoreProps {
  searchResultContainer: ProductCollectionsContainer;
  searchQuery: SearchPagenateQuery;
  searchKeyword?: string;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: () => void;
  setProductCollectionsContainer: (result: PagenatedResponse<ProductCollection>) => void;
}

export const useProductCollectionsStore = create(
  persist<ProductCollectionsStoreProps>(
    (set) => ({
      searchResultContainer: {
        contents: [] as ProductCollection[],
        total: 0,
        page: 0,
        size: 0,
        hasNext: false,
      },
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
        type: 'all',
      },
      setStartDate: (date: string | null) => {
        set((state) => {
          return { ...state, searchQuery: { ...state.searchQuery, startDate: date } };
        });
      },
      setEndDate: (date: string | null) => {
        set((state) => {
          return { ...state, searchQuery: { ...state.searchQuery, endDate: date } };
        });
      },
      searchKeyword: undefined,
      setProductCollectionsContainer: (result) => {
        set((state) => {
          // 메모리 및 localStorage 효율: 현재 페이지 데이터만 저장 (products 스토어와 동일)
          const newValue = {
            ...state.searchResultContainer,
            ...result,
            contents: result?.contents || [],
          };
          return { ...state, searchResultContainer: newValue };
        });
      },
      setSearchKeyword: (keyword: string) => {
        set((state) => {
          return {
            ...state,
            searchKeyword: keyword,
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      updateSearchQuery: (query: { [key: string]: any }) => {
        set((state) => {
          return {
            ...state,
            searchQuery: { ...state.searchQuery, ...query },
            searchResultContainer: { ...state.searchResultContainer, size: 0 },
          };
        });
      },
      resetSearchQuery: () => {
        set({
          searchQuery: {
            page: 0,
            size: PAGE_SIZE,
            type: 'all',
          },
        });
      },
    }),
    {
      name: 'igogo-admin-product-collections',
      storage: createSafeStorage(),
      partialize: createSizePartialize<ProductCollectionsStoreProps>(100),
    },
  ),
);
